import { ReactNode, useEffect, useRef, useState } from 'react';
import { useAccordionContext } from '../AccordionContext';

export interface AccordionContentProps {
	testId?: string;
	panelId: string;
	children: ReactNode;
	className?: string;
}

const AccordionContent = (props: AccordionContentProps) => {
	const { testId = 'AccordionContent', panelId, children, className } = props;
	const { openPanels } = useAccordionContext();
	// ref for the the panel content div
	const contentRef = useRef<HTMLDivElement>(null);
	// panel height, used to open/close the panel to the exact height of its content
	const [panelHeight, setPanelHeight] = useState(0);
	// panel is considered "open" if the context's openPanels set has panelId
	const isOpen = openPanels.has(panelId);

	useEffect(() => {
		// some trickery to set open panel height to match content...enabling a transition.
		// css doesn't like to do transitions with auto heights
		const handleOpenAndResize = () => {
			if (isOpen) {
				setPanelHeight(contentRef.current?.scrollHeight ?? 300);
			} else {
				setPanelHeight(0);
			}
		};

		handleOpenAndResize();

		window.addEventListener('resize', handleOpenAndResize);
		return () => {
			window.removeEventListener('resize', () => handleOpenAndResize());
		};
	}, [isOpen, openPanels]);

	return (
		<div
			data-testid={testId}
			id={`panel-${panelId}`}
			role="region"
			className={className}
			style={{
				height: panelHeight,
			}}
		>
			<div ref={contentRef}>{children}</div>
		</div>
	);
};

export default AccordionContent;
